import React from 'react';
import {
  Card,
  CardContent,
  Collapse,
  IconButton,
  Stack,
  SxProps,
  Tooltip,
  Typography,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

import { renderTemplateItemStatusContent } from './SectionTemplateItem';
import { ICustomSectionTemplateItem } from '../Step3';

interface ResourceTemplateItemProps {
  orderNumber: string;
  section: ICustomSectionTemplateItem;
  onDelete: (id: string) => void;
}

const containerStyles: SxProps = {
  backgroundColor: 'transparent',
  borderRadius: '10px',
};

const ResourceTemplateItem: React.FC<ResourceTemplateItemProps> = ({
  orderNumber,
  section,
  onDelete,
}) => {
  const isEditable = !section.originalSectionId;

  return (
    <Card elevation={0} sx={containerStyles}>
      <CardContent style={{ padding: '16px 0 0 0' }}>
        <Collapse in={Boolean(section.error)} sx={{ mb: '10px' }}>
          <Typography variant="caption" color="error">
            {section.error}
          </Typography>
        </Collapse>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" alignItems="center" flexGrow={1} mr="15px">
            <div style={{ width: '100%' }}>
              <Typography
                maxWidth="calc(100% - 20px)"
                display="flex"
                alignItems="center"
                fontSize="16px"
                fontWeight={600}
                className="ellipsis-text one-line"
              >
                {renderTemplateItemStatusContent(section)}
                {orderNumber}. {section.curriculum} -{' '}
                {section.quiztopiyaTopicName} - {section.quiztopiyaSubTopicName}
              </Typography>
            </div>
          </Stack>
          {isEditable ? (
            <Stack direction="row" alignItems="center" gap="10px">
              <Tooltip title="Delete" placement="top">
                <IconButton color="error" onClick={() => onDelete(section._id)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ResourceTemplateItem;
